module.exports = __webpack_public_path__ + "img/6.c29ee876.gif";